(function() {
    var cities = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('value'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        remote: {
            url: '/api/cities/search/%QUERY/y',
            wildcard: '%QUERY'
        }
    });

    $('#citySearch').typeahead(null, {
        source: cities,
        name: 'cities',
        display: 'name',
        templates: {
            empty: '<div class="col-md-12 "><a href="#"><span>No Results Found.</span></a></div>',
            suggestion: function (city) {
                return '<div class="col-md-12"><a href="#"><span>'+city.name+'</span></a></div>';
            }
        }
    }).on('typeahead:selected', function(e){
        var cityName = this.value;
        $.ajax({
            url: '/api/city/'+cityName+'/set',
            success: function(){
                location.reload();
            }
        });
    });

    $('#changeState').on('click', function(){
        $(this).slideUp();
        $('#statesDiv').slideDown();
        $('.selectState').slideDown();
        $('.city-set').slideUp();
    });

    $('.city-set').on('click', '.citySelect', function(){
        var cityName = $(this).data('cityname');
        $.ajax({
            url: '/api/city/'+cityName+'/set',
            success: function(){
                location.reload();
            }
        });
    });

    $('.stateSelect').on('click', function(){
        $('.selectState').slideUp();
        var stateId = $(this).data('id');
        $('#statesDiv').slideUp();
        $('#changeState').slideDown();
        $('.city-set div').remove();
        $('.state-name').html('Loading...');
        $.ajax({
            url: '/api/cities/state/'+stateId+'/y',
            success: function(data) {
                $('.state-name').html(data.state.name);
                if(data.state && data.state.cities.length)
                {
                    $.each(data.state.cities, function(index, city){
                        $('.city-set').append('<div class="col-md-3"><a href="#" class="citySelect" data-cityname="'+city.name+'"> '+city.name+'</a></div>');
                    });
                }
                else
                {
                    $('.city-set').append('<div class="col-md-12"><p class="text-warning text-center lead">We will be coming soon to '+data.state.name+'</p></div>');
                }
                $('.city-set').slideDown();
            }
        });
    });
})();